import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { OfbizEditDialogComponent } from './ofbiz-edit-dialog.component';
import { OfbizFormsService } from './ofbiz-forms.service';
import { OfbizListService } from './ofbiz-list/ofbiz-list.service';
import { LocalDataSource } from 'angular2-smart-table';

@Component({
  selector: 'ubs-ofbiz-find-results',
  templateUrl: './ofbiz-find-results.component.html',
  styleUrls: ['./ofbiz-find-results.component.scss']
})
export class OfbizFindResultsComponent implements OnInit,OnChanges {
  @Input() listForm:any;
  @Input() result:any[];
  @Input() ofbizForm:any;
  @Input() state:any;
  isLookup = true;

  fieldOptions:any = {};
  listOptions:any = {};

  fieldList:any;
  listSize:number;
  componentConfig:any;

  settings:any = {
    mode:'external',
    hideSubHeader: true,
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    pager:{
      perPage:50
    },
    actions:{
      position:"right",
      add:false
    }
  }

  source: LocalDataSource = new LocalDataSource();
  loaded = false;

  @Output() editSelected = new EventEmitter();

  constructor(private dialogService: NbDialogService,
    private ofbizListService:OfbizListService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["ofbizForm"]){
      if(this.ofbizForm){
        this.fieldList = this.ofbizForm["fields"];
      }
    }
    if(changes["listForm"]){
      if(this.listForm){
        console.log(this.listForm);
        //Field options
        this.fieldOptions.formName = this.listForm.fieldFormName;
        this.fieldOptions.entityName = this.listForm.entityName;
        this.fieldOptions.formLocation = this.listForm.fieldFormLocation;
        //List options
        this.listOptions.formName = this.listForm.listFormName;
        this.listOptions.entityName = this.listForm.entityName;
        this.listOptions.formLocation = this.listForm.listFormLocation;
        this.listOptions.viewIndex = this.listForm.viewIndex;
        this.listOptions.endPoint = this.listForm.endPoint;
        //this.getForm(this.fieldOptions);
        if(this.listForm.columnFields){
          this.fieldList = this.listForm.columnFields;
        }
      }
    }
    //if(changes["state"]){
      //console.log(this.state);
      /* this.state.subscribe(data => {
        console.log(data);
      }); */
      //this.componentConfig = this.state["cmsComponentConfig"]
      /* this.state.subscribe(data => {
        this.componentConfig = data["cmsComponentConfig"];
      }); */
    //}
    if(changes["result"]){
      this.state.subscribe(data => {
        this.componentConfig = data["componentConfig"];
      });
      //console.log(this.state);
      //console.log({"result":this.result});
      if(this.result){
        this.listSize = this.result.length;
      }
      //create columns
      if(this.listForm && this.listForm.columnFields){
        this.settings["columns"] = this.ofbizListService.createColumns(this.fieldList,this.state,this.listOptions,this.isLookup,false)
      }else{
        if(this.listSize > 0){
          this.settings["columns"] = this.ofbizListService.createColumns(this.fieldList,this.state,this.listOptions,this.isLookup,false)
        }
      }
      if(this.listSize > 0){
        this.source.load(this.result);
        this.loaded = true;
      }else{
        this.settings["actions"] = false;
        this.settings.noDataMessage = "No data found for query ";
        this.source.load([]);
        this.source.refresh();
        //console.log({settings:this.settings});
        this.loaded = true;
      }      
      
      /* if(this.listSize > 0){
        let item = this.result[0];
        let columns = {};
        let keys = Object.keys(item);
        keys.forEach(key => {
          let field = this.fieldList.find(field => field.name == key);
          if(field){
            columns[key] = {
              "title":field.title,
              "type":"text",
              filter:false,
              sort:true
            }
          }
        });
        this.settings["columns"] = columns;
        this.source.load(this.result);
        this.loaded = true;
      }else{
        this.settings["actions"] = false;
        this.settings.noDataMessage = "No data found for query ";
        this.source.load([]);
        this.source.refresh();
        console.log({settings:this.settings});
        this.loaded = true;
      } */
    }
  }

  editRow(event){
    let context = {
      title: 'Edit '+this.componentConfig.title,
      data: {"state":this.state,"data":event["data"]},
      fieldList:this.fieldList
    }
    this.editSelected.emit(context);
    /* this.dialogService.open(OfbizEditDialogComponent, {
      context: {
        title: 'Edit '+this.componentConfig.title,
        data: {"state":this.state,"data":event["data"]},
        fieldList:this.fieldList
      },
    }); */
  }

  deleteRow(event){
    console.log({"event":event});
  }

}
